import { ReactNode } from 'react'
import { connect } from 'react-redux'

import BasePage, { CONNECTION_ERROR } from '../BasePage'

import { STEP_2_VALIDATION_URL } from '../../costants'

import Contractor from '../../components/people/contractor/Contractor'
import SiNo, { SiNoType, getBoolean, getSiNoValue } from '../../components/siNo/SiNo'
import { isValidPrivacy, getPrivacyForSubmit } from '../../components/privacy/BasicPrivacy'

import LoginRegister from '../../components/login/LoginRegister'
import CommonsPolicyFields from '../../components/commons/CommonsPolicyFields'
import NoMotorPrivacy from '../../components/privacy/NoMotorPrivacy'
import ModalFinalQuestion from '../../components/final/ModalFinalQuestion'

import SinglePage from '../../components/pagination/SinglePage'
import Pagination from '../../components/pagination/Pagination'

import { authFetch } from '../../libs/cookie/Cookie'

import Select from '../../libs/ui/inputs/Select'
import ModalWaith from '../../libs/ui/modal/ModalWaith'
import ModalNotification from '../../libs/ui/modal/ModalNotification'

import { isNotValidScadenzaPolizza } from '../../libs/validation/dateValidation'
import { CompleteValidationError } from '../../libs/validation/completeValidationError'

import { bicycleUpdate, bicycleInitialState, BicyclePageState, BicyclePageProps } from './BicycleSilce'

import { getTipoBicicletta, getTipoParcheggioBici, getTipoUtilizzoBici, getFasciaPrezzoBici } from '../../libs/initialization/remoteInits'

import { ZUKO_TRAK_ID } from '../../trak/zuko'

import { store } from '../../redux/store'

import '../../sass/App.scss'


class BicyclePage extends BasePage<BicyclePageProps, BicyclePageState> {
    constructor (props: any) {
        super(props)

        this.state = {
            ...bicycleInitialState,
            ...props
        }

        // metodi ereditati
        this.getInitialState = this.getInitialState.bind(this)
        this.getValidationError = this.getValidationError.bind(this)
        this.printError = this.printError.bind(this)
        this.getRilevanzaForSubmit = this.getRilevanzaForSubmit.bind(this)
        this.getSpecificDataForSubmit = this.getSpecificDataForSubmit.bind(this)
        this.saveStateAndRedux = this.saveStateAndRedux.bind(this)

        // metodi specifici del preventivatore
        this.updateTipoBicicletta = this.updateTipoBicicletta.bind(this)
        this.updateTipoParcheggioBici = this.updateTipoParcheggioBici.bind(this)
        this.updateTipoUtilizzoBici = this.updateTipoUtilizzoBici.bind(this)
        this.updateFasciaPrezzoBici = this.updateFasciaPrezzoBici.bind(this)

        this.updateTipo_veicolo = this.updateTipo_veicolo.bind(this)
        this.updateTipo_parcheggio = this.updateTipo_parcheggio.bind(this)
        this.updateTipo_utilizzo = this.updateTipo_utilizzo.bind(this)
        this.updateGare = this.updateGare.bind(this)
        this.updateFascia_prezzo = this.updateFascia_prezzo.bind(this)

        this.step2Validation = this.step2Validation.bind(this)
    }

    componentDidMount(): void {
        super.componentDidMount()
        
        const Zuko = window.Zuko

        if (Zuko && ZUKO_TRAK_ID) {
            Zuko.trackForm( {target: document.body, slug: ZUKO_TRAK_ID} ).trackEvent(Zuko.FORM_VIEW_EVENT)
        }

        if (this.state.tipoBicicletta === undefined) {
            getTipoBicicletta(this.updateTipoBicicletta, this.manageExpiredSessions)
        }
        if (this.state.tipoParcheggioBici === undefined) {
            getTipoParcheggioBici(this.updateTipoParcheggioBici, this.manageExpiredSessions)
        }
        if (this.state.tipoUtilizzoBici === undefined) {
            getTipoUtilizzoBici(this.updateTipoUtilizzoBici, this.manageExpiredSessions)
        }
        if (this.state.fasciaPrezzoBici === undefined) {
            getFasciaPrezzoBici(this.updateFasciaPrezzoBici, this.manageExpiredSessions)
        }
    }

    render(): ReactNode {
        const isLogged = this.state.expiredSessionError === false ? this.state.user !== undefined : false

        const erroOccours = this.state.globalError !== undefined

        return (
            <>
                <article className='container-fluid py-5'>

                    <div className='row justify-content-center'>
                        <div className='col-12 col-md-8'>

                            <header className='row'>
                                <form id="login_register_form" autoComplete='off'>
                                    <LoginRegister 
                                        isLogged={ isLogged } 
                                        isExpire={ this.state.expiredSessionError }
                                        showTitle={ true }
                                        loggedOkCallBack={ this.logUser }
                                        expiredSessionCallbak={ this.manageExpiredSessions }
                                    />
                                </form>
                            </header>

                            <form id="bicycle_form">
                                <Pagination
                                    maxPagges={2}
                                    actualPage={this.state.actualPage}
                                    updateActualPageCallBack={this.updateActualPage}
                                    manageExpiredSessionsCallBack={this.manageExpiredSessions}
                                >
                                    <SinglePage
                                        show={this.state.actualPage === 1}
                                        pageNumber={1}
                                        isLast={false}
                                        validatePage={this.step1Validation}
                                        updateActualPageCallBack={this.updateActualPage}
                                    >
                                        <Contractor 
                                            people={this.state.contractor}
                                            updatePeopleCallback={this.updateContractor}
                                            user={this.state.user}
                                            updateUserCallBack={ this.updateUser }
                                            expiredSessionCallbak={ this.manageExpiredSessions }
                                            error={this.state.contractorError}
                                            isOnlyFisica={true}
                                            isOnlyGiuridica={false}
                                        />
                                    </SinglePage>

                                    <SinglePage
                                        show={this.state.actualPage === 2}
                                        pageNumber={2}
                                        isLast={true}
                                        validatePage={this.step2Validation}
                                        updateActualPageCallBack={this.updateActualPage}
                                        sendCallBack={this.sendData}
                                    >
                                        
                                        <CommonsPolicyFields 
                                            rilevanza={ this.state.rilevanza }
                                            rilevanzaErrro={ this.state.rilevanzaError }
                                            updateRilevanza={ this.updateRilevanza }

                                            altriSinistri={this.state.altriSinistri}
                                            altriSinistriError={this.state.altriSinistriError}
                                            polizzaAttiva={this.state.polizzaAttiva}
                                            polizzaAttivaError={this.state.polizzaAttivaError}
                                            scadenzaPolizza={this.state.scadenzaPolizza}
                                            scadenzaPolizzaError={this.state.scadenzaPolizzaError}

                                            updateAltriSinistri={this.updateAltriSinistri}
                                            updatePloizzaAttiva={this.updatePloizzaAttiva}
                                            updateScadenzaPolizza={this.updateScadenzaPolizza}
                                        />

                                        <div className='col-12'>
                                            <Select
                                                id='tipo_veicolo' name='tipo_veicolo' key='tipo_veicolo'
                                                label='Qual è il tipo di mezzo da assicurare?' 
                                                value={this.state.tipo_veicolo}
                                                options={this.state.tipoBicicletta}
                                                callback={this.updateTipo_veicolo}
                                                error={this.state.tipo_veicoloError}
                                            />
                                            <Select
                                                id='tipo_parcheggio' name='tipo_parcheggio' key='tipo_parcheggio'
                                                label='Dove custodisci il mezzo?' 
                                                value={this.state.tipo_parcheggio}
                                                options={this.state.tipoParcheggioBici}
                                                callback={this.updateTipo_parcheggio}
                                                error={this.state.tipo_parcheggioError}
                                            />
                                            <Select
                                                id='tipo_utilizzo' name='tipo_utilizzo' key='tipo_utilizzo'
                                                label='Come usi il mezzo?' 
                                                value={this.state.tipo_utilizzo}
                                                options={this.state.tipoUtilizzoBici}
                                                callback={this.updateTipo_utilizzo}
                                                error={this.state.tipo_utilizzoError}
                                            />
                                            <SiNo 
                                                label='Utilizzi il mezzo per gare agonistiche?'
                                                id='gare'
                                                value={ getSiNoValue(this.state.gare) }
                                                callback={this.updateGare}
                                                error={this.state.gareError}
                                            />
                                            <Select
                                                id='fascia_prezzo' name='fascia_prezzo' key='fascia_prezzo'
                                                label='Prezzo di acquisto del mezzo' 
                                                value={this.state.fascia_prezzo}
                                                options={this.state.fasciaPrezzoBici}
                                                callback={this.updateFascia_prezzo}
                                                error={this.state.fascia_prezzoError}
                                            />
                                        </div>

                                        <NoMotorPrivacy 
                                            id='noMotorPrivacy'
                                            basePrivacy={this.state.noMotorPrivacy}
                                            isLogged={this.state.user !== undefined}
                                            callback={this.updateNoMotorPrivacy}
                                            error={this.state.noMotorPrivacyError}
                                        />
                                    </SinglePage>
                                </Pagination>
                            </form>
                        </div>
                    </div>

                    <ModalWaith isOpen={this.state.waith}/>

                    <ModalNotification
                        title='Si è verificato un problema'
                        isError={erroOccours}
                        isOpen={erroOccours}
                        callBackToggle={ () => this.setState ({globalError: undefined}) }
                    >
                        {this.state.globalError}
                    </ModalNotification>

                    <ModalFinalQuestion 
                        isOpen={this.state.finalQuestIsOpen}
                        quoteRequestId={this.state.quoteRequestId}
                        callBackToggle={this.closeFinalQuestion}
                        expiredSessionCallbak={this.manageExpiredSessions}
                    />
                </article>
            </>
        )
    }

    // -- comuni
    getInitialState() {
        return bicycleInitialState
    }

    getValidationError () : Promise<CompleteValidationError> {
        return Promise.all([
            this.step1Validation(),
            this.step2Validation(),
        ])
        .then ((responses) => {
            let p: number | undefined = undefined
            let e: string | undefined  = undefined

            if (responses[0] !== undefined) {
                p = 1
                e = responses[0]
            }
            else if (responses[1] !== undefined) {
                p = 2
                e = responses[1]
            }

            return {
                errorString: e,
                pageError: p
            }
        })
        .catch (() => {
            return {
                errorString: CONNECTION_ERROR,
                pageError: undefined
            }
        })
    }

    printError (errorString: string | undefined, waith: boolean = false, pageError: number | undefined = undefined) {
        const superErrors = super.printError(errorString, waith, pageError)

        if (superErrors?.globalError !== undefined) {
            this.setState( superErrors )
        } 
        else {
            let tipo_veicoloErro = undefined
            let tipo_parcheggioErro = undefined
            let tipo_utilizzoErro = undefined
            let gareErro = undefined
            let fascia_prezzoErro = undefined
            

            let noMotorPrivacyErro = undefined
            
            let global = undefined

            if ( errorString === 'TIPO_VEICOLO') {
                tipo_veicoloErro = 'Selezionare la tipologia del mezzo'
                global = tipo_veicoloErro
            }
            else if ( errorString === 'TIPO_PARCHEGGIO') {
                tipo_parcheggioErro = 'Indicare dove viene custodito il mezzo'
                global = tipo_parcheggioErro
            }
            else if ( errorString === 'TIPO_UTILIZZO') {
                tipo_utilizzoErro = 'Indicare il tipo di utilizzo del mezzo'
                global = tipo_utilizzoErro
            }
            else if ( errorString === 'GARE') {
                gareErro = 'Indicare se il mezzo è utilizzato nelle competizioni'
                global = gareErro
            }
            else if ( errorString === 'FASCIA_PREZZO') {
                fascia_prezzoErro = "Indicare la fascia di prezzo d'aquisto del emzzo"
                global = fascia_prezzoErro
            }
            else if ( errorString === 'PRIVACY' ) {
                noMotorPrivacyErro = 'Selezionare i campi obbligatori'
                global = noMotorPrivacyErro
            } 
            else {
                global = errorString
            }

            this.setState ({
                waith: waith,
                actualPage: pageError ?? this.state.actualPage,

                tipo_veicoloError: tipo_veicoloErro,
                tipo_parcheggioError: tipo_parcheggioErro,
                tipo_utilizzoError: tipo_utilizzoErro,
                gareError: gareErro,
                fascia_prezzoError: fascia_prezzoErro,
                noMotorPrivacyError: noMotorPrivacyErro,

                globalError: global,
            })
        }
    }

    getSpecificDataForSubmit () {
        return {
            sinistriPrecedenti: this.state.altriSinistri ?? false,
            polizzaGiaAttiva: this.state.polizzaAttiva ?? false,
            dataScadenza: (this.state.polizzaAttiva === true) 
                ? (this.state.scadenzaPolizza ?? null)
                : null,

            rilevanza: this.getRilevanzaForSubmit(),

            tipo_veicolo: this.state.tipo_veicolo ?? null,
            tipo_parcheggio: this.state.tipo_parcheggio ?? null,
            tipo_utilizzo: this.state.tipo_utilizzo ?? null,
            gare: this.state.gare ?? null,
            fascia_prezzo: this.state.fascia_prezzo ?? null,
        }
    }

    saveStateAndRedux (newState : object) {
        this.setState(
            newState, () => {
                store.dispatch (
                    bicycleUpdate (this.state)
                )
            }
        )
    }

    // -- solo preventivatores
    updateTipoBicicletta (val : any) {
        this.setState({
            tipoBicicletta: val
        })
    }
    updateTipoParcheggioBici (val : any) {
        this.setState({
            tipoParcheggioBici: val
        })
    }
    updateTipoUtilizzoBici (val : any) {
        this.setState({
            tipoUtilizzoBici: val
        })
    }
    updateFasciaPrezzoBici (val : any) {
        this.setState({
            fasciaPrezzoBici: val
        })
    }

    private updateTipo_veicolo (val: string | undefined) {
        this.saveStateAndRedux({
            tipo_veicolo: val,
            tipo_veicoloError: undefined
        })
    }
    private updateTipo_parcheggio (val: string | undefined) {
        this.saveStateAndRedux({
            tipo_parcheggio: val,
            tipo_parcheggioError: undefined
        })
    }
    private updateTipo_utilizzo (val: string | undefined) {
        this.saveStateAndRedux({
            tipo_utilizzo: val,
            tipo_utilizzoError: undefined
        })
    }
    private updateGare (val: SiNoType) {
        this.saveStateAndRedux({
            gare: getBoolean( val ),
            gareError: undefined
        })
    }
    private updateFascia_prezzo (val: string | undefined) {
        this.saveStateAndRedux({
            fascia_prezzo: val,
            fascia_prezzoError: undefined
        })
    }

    private async step2Validation () {
        let error = undefined

        if (this.state.altriSinistri === undefined) {
            error = 'SINISTRI'
        }
        else if (this.state.polizzaAttiva === undefined) {
            error = 'POLIZZA'
        }
        else if (
            this.state.polizzaAttiva === true && 
            isNotValidScadenzaPolizza(this.state.scadenzaPolizza)
        ) {
            error = 'SCADENZA_POLIZZA'
        }
        else if (this.state.tipo_veicolo === undefined) {
            error = 'TIPO_VEICOLO'
        }
        else if (this.state.tipo_parcheggio === undefined) {
            error = 'TIPO_PARCHEGGIO'
        }
        else if (this.state.tipo_utilizzo === undefined) {
            error = 'TIPO_UTILIZZO'
        }
        else if (this.state.gare === undefined) {
            error = 'GARE'
        }
        else if (this.state.fascia_prezzo === undefined) {
            error = 'FASCIA_PREZZO'
        }

        else if (!isValidPrivacy(this.state.noMotorPrivacy, this.state.user !== undefined)) {
            error = 'PRIVACY'
        }
        else {
            await authFetch (
                STEP_2_VALIDATION_URL,
                {
                    method: "post",
                    body: JSON.stringify({
                        specificData: this.getSpecificDataForSubmit(),
                        privacy: getPrivacyForSubmit( this.state.contractor, this.state.noMotorPrivacy, this.state.user),
                        isLogged: this.state.expiredSessionError === false ? this.state.user !== undefined : false
                    })
                },
                this.manageExpiredSessions,
            ).then ( jsonObj => {
                if (jsonObj.status > 200) {
                    error = jsonObj.msg ?? "Impossibile salvare la richiesta, riporva più tardi."
                }
            }).catch( error => {
                error = CONNECTION_ERROR
            })
        }

        this.printError(error)

        return error
    }

}

const mapState = (state: any) => {
  return {
    contractor: state.contractor,
    altriSinistri: state.altriSinistri,
    polizzaAttiva: state.polizzaAttiva,
    scadenzaPolizza: state.scadenzaPolizza,
    rilevanza: state.rilevanza,

    tipo_veicolo: state.tipo_veicolo,
    tipo_parcheggio: state.tipo_parcheggio,
    tipo_utilizzo: state.tipo_utilizzo,
    gare: state.gare,
    fascia_prezzo: state.fascia_prezzo,
    
    actualPage: state.actualPage,

    noMotorPrivacy: state.noMotorPrivacy,
    user: state.user
  }
}

export default connect(mapState) (BicyclePage)